import React from "react";
// import Link from "next/link";
import { ArrowRight } from "lucide-react";

import MolinosFoto from "../images/Blogs/Molinos.jpg";
import CosechadoraFoto from "../images/Blogs/Cosechadora.jpg";
import ChoferFoto from "../images/Blogs/Chofer.jpg";

// Simulated blog data
const blogs = [
  {
    id: 1,
    title: "Innovaciones en el transporte de semillas",
    excerpt: "Descubre las últimas tecnologías que están revolucionando el transporte de semillas...",
    date: "2023-09-15",
    image: MolinosFoto,
  },
  {
    id: 2,
    title: "Mejores prácticas para el almacenamiento de semillas",
    excerpt: "Aprende cómo maximizar la vida útil y calidad de las semillas con estas técnicas de almacenamiento...",
    date: "2023-09-10",
    image: CosechadoraFoto,
  },
  {
    id: 3,
    title: "El impacto de la logística en la agricultura moderna",
    excerpt: "Analizamos cómo una logística eficiente está transformando la industria agrícola...",
    date: "2023-09-05",
    image: ChoferFoto,
  },
];

export default function Blogs() {
  return (
    <div className="py-12 md:py-24 lg:py-32">
      <div className="container px-4 md:px-6">
        <h2 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl lg:text-7xl mb-20">
          Nuestros Blogs
        </h2>
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
          {blogs.map((blog) => (
            // <Link href={`/blogs/${blog.id}`} key={blog.id} className="group">
            <a href={`/blog`} key={blog.id} className="group">
              <div className="relative overflow-hidden rounded-2xl">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="object-cover w-full h-64 transition-transform duration-300 group-hover:scale-110 rounded-2xl"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 transition-opacity duration-300 opacity-0 group-hover:opacity-100 flex items-center justify-center">
                  <ArrowRight className="w-10 h-10 text-white" />
                </div>
              </div>
              <h2 className="mt-4 text-2xl font-semibold">{blog.title}</h2>
              <p className="mt-2 text-muted-foreground">{blog.excerpt}</p>
              <p className="mt-2 text-sm text-muted-foreground">{blog.date}</p>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}